export default {
  "path": "/demo/lazy-load-index",
  "meta": {
    "name": "demo-懒加载",
    "title": "LazyLoad 懒加载",
    "isComponentDoc": true,
    "category": "Basic"
  }
};